
export default function Support() {
  return (
    <div>
      Support Page
    </div>
  )
}